export default "__VITE_ASSET__45ba9b5a__"